import { put, takeLatest } from 'redux-saga/effects';
import { GraphQL, gql } from 'core';
import actionTypes, { requestResetPasswordAction } from './types';
import actions from './actions';

export function* resetPasswordRequestSaga({ email }: ReturnType<requestResetPasswordAction>) {
  yield put(actions.requestResetPasswordPending());

  try {
    const {
      data: { resetUserPassword }
    } = yield GraphQL.mutate({
      mutation: gql`
        mutation sendPasswordResetLinkMutation($email: String!) {
          resetUserPassword(email: $email) {
            success
          }
        }
      `,
      variables: {
        email
      },
      fetchPolicy: 'no-cache'
    });
    if (resetUserPassword?.success) {
      yield put(actions.requestResetPasswordSuccess());
    } else {
      yield put(actions.requestResetPasswordFailure());
    }
  } catch (error) {
    yield put(actions.requestResetPasswordError((error as { message: string })?.message));
  }
}

export default function* watchIncrementAsync() {
  yield takeLatest(actionTypes.REQUES_RESET_PASSWORD, resetPasswordRequestSaga);
}
